import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { setOrderAction } from '~src/app/actions/SetOrderAction';
import { enterSpace } from '~src/app/actions/spaces/EnterSpaceAction';
import { requestSpaceContents } from '~src/app/actions/spaces/RequestSpaceContentsActions';
import { getOrderClausesFromQueryParam } from '~src/app/spaces/Explorer/ExplorerUrlBindings';
import { SpaceInfo } from '~src/app/state/SpaceInfo';
import { UrlParamKeys } from '~src/app/UrlParamKeys';
import { Messages } from '~src/codegen/Localize';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { getDefaultOrderForPublishedConnectionTableSubSpace } from '~src/ts/models/sort/SortOptionDefinitions';

import { EnterPublishedConnectionTableSubspaceReduxAction } from '../actions/EnterPublishedConnectionTableSubspaceAction';

export function* handleEnterPublishedConnectionTableSubspace(action: EnterPublishedConnectionTableSubspaceReduxAction): SagaIterator {
  try {
    const spaceInfo: SpaceInfo = {
      item: action.publishedConnectionTableDetailInfo,
      spaceType: 'publishedConnectionTable',
      subspaceName: action.subspaceName,
    };
    yield put(enterSpace(spaceInfo));
    if (action.requestContent) {
      const hashQuery: any = WindowLocationService.getHashQueryObject();
      const orderFromQuery = getOrderClausesFromQueryParam(
        hashQuery[UrlParamKeys.Order],
        getDefaultOrderForPublishedConnectionTableSubSpace(spaceInfo)
      );
      yield put(setOrderAction(orderFromQuery));
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
